module.exports = __webpack_public_path__ + "img/00030.c48d51d6.webp";